import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconInfoProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconInfo: React.FC<IconInfoProps> = ({
    color = 'info',
    size = 'md',
    className = '',
    title = 'Info',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 16v-4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 8h.01" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconInfo;
